"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Apparatus = void 0;
var cerealParse_1 = require("../cerealParse");
var apparatusType_1 = require("./apparatusType");
var client_1 = require("./client");
var device_1 = require("./device");
/**
 * Class representing an apparatus and providing a static parse method.
 */
var Apparatus = /** @class */ (function () {
    function Apparatus(id, email, name, apparatusId, apparatusType, device) {
        this.id = id;
        this.email = email;
        this.name = name;
        this.apparatusId = apparatusId;
        this.apparatusType = apparatusType;
        this.device = device;
    }
    /**
     * Parse object potentially representing an Apparatus
     * @param o
     * @return Parse result
     */
    Apparatus.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Apparatus(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'email'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'apparatusId'), cerealParse_1.ParseUtils.getEnum(o, 'apparatusType', apparatusType_1.ApparatusTypeEnum), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'device', device_1.MinimalDevice.parse)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Apparatus Model: ".concat(e.message));
        }
    };
    /**
     * Replace fields of apparatus with those of another apparatus.
     * @param other
     */
    Apparatus.prototype.replaceFields = function (other) {
        // ID is left unchanged
        this.email = other.email;
        this.name = other.name;
        this.apparatusId = other.apparatusId;
        this.apparatusType = other.apparatusType;
    };
    /**
     * Create Client instance based on Apparatus.
     * @return CLient representing apparatus.
     */
    Apparatus.prototype.toClient = function () {
        return new client_1.Client(this.id, this.name, client_1.AgencyClientType.apparatus);
    };
    return Apparatus;
}());
exports.Apparatus = Apparatus;
//# sourceMappingURL=apparatus.js.map